import { useCallback, useEffect, useState } from "react";
import { BasicTable } from "../components/tables/BasicTable";
import { Pagination } from "../components/pagination/Pagination";
import { formatDate } from "../utils/dateAndTime";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllFights } from "../services/fightsAPI";
import { Search } from "../components/search/Search";
import Loader from "../components/ui/loader";

export const Fights = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handleTeamClick = (teamID) => {
    navigate(`/team/${teamID}`);
  };
  const handleGameClick = (gameID) => {
    navigate(`/game/${gameID}`);
  };

  const handleLeagueClick = (leagueID) => {
    navigate(`/league/${leagueID}`);
  };

  const columns = [
    { key: "FightID", label: "ID", itemID: "Game.GameID", clickHandler: handleGameClick },
    {
      key: "date",
      label: "Date",
      format: formatDate,
      itemID: "Game.GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "fightType",
      label: "Fight Type",
      itemID: "Game.GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "description",
      label: "Fight Description",
      itemID: "Game.GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "LeagueDetails.name",
      label: "League",
      itemID: "LeagueDetails.LeagueID",
      clickHandler: handleLeagueClick,
    },
    {
      key: "SeasonDetails.season",
      label: "Season",
      itemID: "Game.GameID",
      clickHandler: handleGameClick,
    },
    {
      key: "Game.HomeTeamDetails.city",
      itemID: "Game.HomeTeamDetails.TeamID",
      label: "Home Team",
      clickHandler: handleTeamClick,
    },
    {
      key: "Game.AwayTeamDetails.city",
      itemID: "Game.AwayTeamDetails.TeamID",
      label: "Away Team",
      clickHandler: handleTeamClick,
    },
    {
      key: "Fights",
      label: "# of Fights",
      format: (fights) => (fights ? fights.length : 0),
      itemID: "Game.GameID",
      clickHandler: handleGameClick,
    },
  ];

  const searchCategories = [
    { value: "id", label: "ID" },
    { value: "date", label: "Date" },
    { value: "fightType", label: "Fight Type" },
    { value: "league", label: "League" },
    { value: "season", label: "Season" },
    { value: "homeTeam", label: "Home Team" },
    { value: "awayTeam", label: "Away Team" },
  ];

  const [fightData, setFightData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const fetchFights = useCallback(async () => {
    try {
      setIsLoading(true);
      let response = await getAllFights(location.search);
      console.log(response);
      if (response.success) {
        setFightData(response.data.fights);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchFights();
  }, [fetchFights]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh] bg-flyers-black">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
          Fights
        </h1>
        <Search categories={searchCategories} />
        <BasicTable columns={columns} data={fightData} />
        <Pagination pagination={pagination} />
      </div>
    </div>
  );
};
